import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';
import { DependencyProjectInputProps } from './DependencyProjectInputProps';
import useTranslation from '../../hooks/useTranslation';
import { isOptionEqualToValue } from './utils';

const DependencyProjectInput: FC<DependencyProjectInputProps> = ({
  projects,
}) => {
  const { control } = useFormContext();
  const t = useTranslation();
  return (
    <Controller
      name={'mergedWithReferenceId'}
      control={control}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
        const currentValue =
          (value &&
            projects.find(
              (project) =>
                project.referenceId === value || project.id === value,
            )) ||
          null;

        return (
          <Autocomplete
            id="mergedWithReferenceId"
            options={projects}
            disabled={!projects?.length}
            data-testid={'project-link-dependency'}
            value={currentValue}
            getOptionLabel={(option) =>
              `${option.projectName || 'Unnamed Project'} - ${
                option.referenceId || option.id || 'No Reference ID'
              }`
            }
            isOptionEqualToValue={isOptionEqualToValue}
            onChange={(_, data) => {
              if (data && typeof data === 'object' && 'referenceId' in data) {
                onChange(data.referenceId || data.id || null);
              } else {
                onChange('');
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('labels.dependencyLink')}
                inputRef={ref}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <div>
                  <strong>{option.projectName || 'Unnamed Project'}</strong>
                  <br />
                  <small>
                    Reference ID: {option.referenceId || 'No Reference ID'}
                  </small>
                  <br />
                  <small>ID: {option.id}</small>
                </div>
              </li>
            )}
          />
        );
      }}
    />
  );
};

export default DependencyProjectInput;
